module.exports = __webpack_public_path__ + "img/261.e30f258a.png";